import * as React from "react";
import { forwardRef } from "react";
const ArrowRoadIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M10.301 18.8a.68.68 0 0 1 .678.678v2.546a.68.68 0 0 1-.678.678.68.68 0 0 1-.678-.678v-2.546a.68.68 0 0 1 .678-.678zm8.532 2.91a.68.68 0 0 1-.39.876.68.68 0 0 1-.876-.391l-5.071-13.23.633-.242.633-.243 5.071 13.229zM6.839 8.48a.68.68 0 0 1 .876-.39.68.68 0 0 1 .39.875l-5.071 13.23a.68.68 0 0 1-.875.391.68.68 0 0 1-.391-.876L6.839 8.48zm3.462 4.765a.68.68 0 0 1 .678.678v2.5a.68.68 0 0 1-.678.678.68.68 0 0 1-.678-.678v-2.5a.68.68 0 0 1 .678-.678zm6.963-11.076a.68.68 0 0 1 .852.087.68.68 0 0 1-.001.959l-1.678 1.677h2.13c.392 0 1.489-.131 2.35.718.835.823 1.309 2.396 1.257 5.238a.677.677 0 1 1-1.354-.024c.051-2.784-.446-3.845-.855-4.248-.382-.377-.802-.328-1.398-.328h-2.13l1.678 1.677a.68.68 0 0 1 .001.959.68.68 0 0 1-.959 0L14.321 6.05a.68.68 0 0 1 0-.959l2.836-2.834.107-.087zm-6.963 6.178a.68.68 0 0 1 .678.678v1.776a.68.68 0 0 1-.678.678.68.68 0 0 1-.678-.678V9.024a.68.68 0 0 1 .678-.678z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.887 8.091a.68.68 0 0 1 .875.39l-1.266.485a.68.68 0 0 1 .391-.875z"
}));
const ForwardRef = forwardRef(ArrowRoadIcon);
export default ForwardRef;